var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sort"},[_c('h1',[_vm._v(_vm._s(_vm.title))]),_c('v-select',{attrs:{"items":_vm.selectItems,"label":"排序方式","dense":"","solo":""},on:{"change":_vm.getList},model:{value:(_vm.queryParams.orderBy),callback:function ($$v) {_vm.$set(_vm.queryParams, "orderBy", $$v)},expression:"queryParams.orderBy"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }